import React from "react";

function BS4_Cards() {
  return (
    <div>
      <h1>BS4_Cards Component</h1>
      <p>This is the BS4_Cards tutorial page content.</p>
    </div>
  );
}

export default BS4_Cards;
